import styled, { css } from 'styled-components';
import { Icon, IconButton, loading } from '@web-chat-core/ui-kit';

export const SummaryButtonLayout = styled(IconButton)<{ $isActive?: boolean; $isMobile?: boolean }>`
    height: 40px;
    width: 40px;

    ${({ $isMobile }) =>
        $isMobile
            ? css`
                  padding: 4px;
                  height: 32px;
                  width: 32px;
              `
            : null}

    &:disabled {
        &:before,
        &:active:before,
        &:focus:before,
        &:hover:before {
            background: ${({ theme, $isActive }) =>
                $isActive ? theme.root.colors.basicColors['90%'] : theme.root.colors.basicColors['90%']};
            opacity: 60%;
        }
    }

    &:before {
        background: ${({ theme, $isActive }) =>
            $isActive ? theme.root.colors.basicColors['90%'] : theme.root.colors.basicColors['10%']};

        ${({ $isMobile }) =>
            $isMobile
                ? css`
                      border-radius: 6px;
                      height: 32px;
                      width: 32px;
                  `
                : null}
    }

    &:active:before,
    &:focus:before,
    &:hover:before {
        background: ${({ theme, $isActive }) =>
            $isActive ? theme.root.colors.basicColors['90%'] : theme.root.colors.basicColors['15%']};
    }

    &:after {
        right: 0;
        left: auto;
        transform: translateY(-100%);
        white-space: nowrap;
    }
`;

export const SummaryIcon = styled(Icon)<{ $isActive?: boolean }>`
    --icon-color: ${({ theme, $isActive }) =>
        $isActive ? theme.root.colors.basicColors.black['95%'] : theme.root.colors.basicColors['90%']};
    position: relative;
`;

export const LoadingIcon = styled(Icon)`
    --ic-inner-color: ${(props) => props.theme.root.colors.basicColors['90%']};
    position: relative;
    ${loading}
`;
